CONSTANTS = new (function () {
  this.ALERT_TYPES = {
    error: "error",
    success: "success",
    warning: "warning",
    info: "info",
  };

  this.COLORS = {
    primary: "#2B439C",
    white: "#fff",
    hoveredRow: "#f1f3f7f2",
    filled: "#506bd0",
    disabled: "#C2C9D9",
    fitness: {
      score: "#397BFF",
      year: "#3BC583",
      database: "#F28B2C",
      class: "#A82FE2",
    },
  };

  this.ALERTS = {
    NO_RESULTS: "No Results.",
    SUCCESS: "Changes were applied.",
  };

  this.SELECT2_DEFAULTS = {
    placeholder: "- Select -",
    allowClear: true,
    width: "100%",
    theme: "bootstrap4",
  };

  this.SELECT_VALUES = {
    allSubjects: " ",
    mostRecent: 3,
  };

  this.ALLOWED_EXTENSIONS = [".xls", ".xlsx", ".csv"];

  this.ALLOWED_FILESIZE = 2097152;
})();

GRAPH_CONSTANTS = new (function () {
  this.paths = {
    actual: "actual",
    expected: "expected",
    actualH: "actualH",
    actualF: "actualF",
    actualO: "actualO",
    actualC: "actualC",
  };

  this.colors = {
    actualResult: "#506bd0",
    expectedResult: "#ffa700",
    targetResult: "#d2d4ff",
    white: "#fff",
    green: "#119c59",
    yellow: "#f5d10d",
    red: "#f76d4c",
    neutral: "#f1f3f7",
    orange: "#f2994a",
    blue: "#3366cc",
    grey: "#9aa6bd",
    black: "#000000",
  };

  this.MAX_RESULT = 100;
  this.MIN_RESULT = 0;
  this.EXPECTATION_GAP = -5;

  this.dimensions = {
    height: 260,
    radius: 2.75,
    sWidth: 2,
    left: 38,
    top: 15,
    scale: 1.94,
    barWidth: 22,
    actCapHeight: 3,
    actCapWidth: 28,
    expCapHeight: 7,
    expCapWidth: 32,
    fontSize: 10,
  };

  this.googleToolTip = {
    className: "google-visualization-tooltip",
    spacer: 14,
    exceedYCoor: 65,
    exceedXCoor: 1000,
    offsetX: (x, bool) => x + (bool ? this.dimensions.actCapWidth : this.dimensions.expCapWidth),
    rightPath: (bool, x, y) =>
      bool
        ? `M${x - 56},${y - 14}A1,1,0,0,1,${x - 57},${y - 15}L${x - 57},${y - 61}A1,1,0,0,1,${x - 56},${y - 62}L${
            x + 90
          },${y - 62}A1,1,0,0,1,${x + 91},${y - 61}L${x + 91},${y - 15}A1,1,0,0,1,${x + 90},${y - 14}L${x + 28},${
            y - 14
          }L${x},${y}L${x + 14},${y - 14}Z`
        : `M${x - 56},${y + 62}A1,1,0,0,1,${x - 57},${y + 61}L${x - 57},${y + 15}A1,1,0,0,1,${x - 56},${y + 14}L${
            x + 14
          },${y + 14}L${x},${y}L${x + 28},${y + 14}L${x + 90},${y + 14}A1,1,0,0,1,${x + 91},${y + 15}L${x + 91},${
            y + 61
          }A1,1,0,0,1,${x + 90},${y + 62}Z`,
    leftPath: (bool, x, y) =>
      bool
        ? `M${x - 85},${y - 14}A1,1,0,0,1,${x - 86},${y - 15}L${x - 86},${y - 61}A1,1,0,0,1,${x - 85},${y - 62}L${
            x + 61
          },${y - 62}A1,1,0,0,1,${x + 62},${y - 61}L${x + 62},${y - 15}A1,1,0,0,1,${x + 61},${y - 14}L${x - 14},${
            y - 14
          }L${x},${y}L${x - 28},${y - 14}Z`
        : `M${x - 85},${y + 62}A1,1,0,0,1,${x - 86},${y + 61}L${x - 86},${y + 15}A1,1,0,0,1,${x - 85},${y + 14}L${
            x - 28
          },${y + 14}L${x},${y}L${x - 14},${y + 14}L${x + 61},${y + 14}A1,1,0,0,1,${x + 62},${y + 15}L${x + 62},${
            y + 61
          }A1,1,0,0,1,${x + 61},${y + 62}Z`,
    dimensions: {
      "font-weight": "bold",
      "text-anchor": "start",
      yCoor: (y, bool) => y - (bool ? 40 : -35),
      xCoor: (x, bool) => x - (bool ? 48 : 78),
      "font-size": 12,
      "font-family": "Arial",
      stroke: "none",
      "stroke-width": 0,
    },
  };
})();
